import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=50dc322e&scoped=true&"
import script from "./ModalWrapper.vue?vue&type=script&lang=js&"
export * from "./ModalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=50dc322e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc322e",
  null
  
)

export default component.exports